<template>
    <div>
        {{facility}}
        <facility-selector v-model="facility"></facility-selector>
    </div>
</template>

<script>
  import FacilitySelector from './FacilitySelector'
  export default {
    name: 'FacilitySwitch',
    components: { FacilitySelector },
    data() {
      return {
        facility: this.$store.state.pointsListStore.pointsList.facility_name
      }
    },
    computed: {
      facility_id () {
        for (let i in this.$store.state.facilityStore.facilityList){
          if (this.$store.state.facilityStore.facilityList[i].facility_name==this.facility){
            return this.$store.state.facilityStore.facilityList[i].facility_id
          }
        }
        return null
      }
    },
    watch: {
      facility() {
        this.$store.dispatch('refreshPointsList', this.facility_id)
        this.$store.dispatch('callSnackbar', {active: true, text: "Switch to facility"+this.facility})
      }
    }
  }
</script>

<style scoped>

</style>
